import React from "react";
import { Heart } from "lucide-react";
import landing from "@/content/landing";
import { Section } from "./HeroSection";

export default function PeopleSection() {
  const t = landing.people;
  return (
    <Section id="people" className="bg-white" data-testid="landing-people">
      <div className="max-w-3xl">
        <div className="ag-overline mb-4">Für wen</div>
        <h2 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
          {t.headline}
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-4 sm:mt-16 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
        {t.items.map((item) => (
          <article
            key={item.key}
            className="ag-premium-card flex flex-col gap-4 p-6"
            data-testid={`landing-people-item-${item.key}`}
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-rose-50 to-amber-50 text-rose-600" aria-hidden="true">
              <Heart className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <h3 className="font-serif text-xl leading-tight text-ag-ink">{item.title}</h3>
            <p className="text-sm leading-relaxed text-slate-600">{item.text}</p>
          </article>
        ))}
      </div>

      <div className="mt-16 max-w-3xl border-l-2 border-amber-500/70 pl-6">
        <p className="font-serif text-xl italic leading-snug text-slate-700 sm:text-2xl">
          {t.closing}
        </p>
      </div>
    </Section>
  );
}
